import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Paper, Snackbar, Alert, CircularProgress } from '@mui/material';
import FormDisciplina from '../../components/Disciplinas/FormDisciplina';
import { criarDisciplina, obterDisciplina, atualizarDisciplina } from '../../services/disciplinaService';

const CriarEditarDisciplinaPage = () => {
  const [disciplina, setDisciplina] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode) {
      setLoading(true);
      const fetchDisciplina = async () => {
        try {
          const data = await obterDisciplina(id);
          setDisciplina(data);
        } catch (error) {
          console.error('Erro ao buscar disciplina:', error);
          setError('Não foi possível carregar os dados da disciplina. Por favor, tente novamente.');
        } finally {
          setLoading(false);
        }
      };

      fetchDisciplina();
    }
  }, [id, isEditMode]);

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError('');
    try {
      if (isEditMode) {
        await atualizarDisciplina(id, formData);
        setSuccessMessage('Disciplina atualizada com sucesso!');
      } else {
        await criarDisciplina(formData);
        setSuccessMessage('Disciplina criada com sucesso!');
      }
      setTimeout(() => navigate('/disciplinas'), 2000);
    } catch (error) {
      console.error('Erro ao salvar disciplina:', error);
      setError('Ocorreu um erro ao salvar a disciplina. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (loading && isEditMode) {
    return <CircularProgress />;
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {isEditMode ? 'Editar Disciplina' : 'Criar Nova Disciplina'}
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <FormDisciplina 
        onSubmit={handleSubmit} 
        disciplinaInicial={disciplina}
        isLoading={loading}
      />
      <Snackbar
        open={!!successMessage}
        autoHideDuration={2000}
        onClose={() => setSuccessMessage('')}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          {successMessage}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default CriarEditarDisciplinaPage;